<template>
  <div>
    <div class="modal-card">
      <header class="modal-card-head">
          <h3 class="modal-card-title is-size-3 has-text-black-bis
          is-capitalized has-text-weight-bold">
            Item Deliveries
           </h3>
          <div class="is-divider-vertical"></div>
          <i class="icon-close is-clickable" @click="$emit('close')"></i>
      </header>
      <section class="modal-card-body is-marginless is-visible pt-0">
        <div class="columns mb-0">
          <div class="column">
            <h4 class=" has-text-black-bis has-text-weight-bold is-italic  mb-0">
              Item :  <span class="has-text-black-bis has-text-weight-light is-size-5 has-text-weight-normal">{{ rowData.name }} </span>
            </h4>
          </div>
        </div>
        <search-bar
          placeholder="Search"
          :shouldEmit="shouldEmit"
          @search="getSearchValue($event)"> 
        </search-bar>
        <div class="my-2">
          <mf-table
          :tableProps="tableProps"
          :loadData="loadData"
          ref="itemsTable"
          :apiMode="true"
          :hideGutter="true">
            <template v-slot:qtyShort>
              <div >
                {{
                  rowData.qtyShort ?? 0
                }}
              </div>
            </template>
            <template v-slot:itemDeliveries="{ rowData: delivery}">
              <field-stage
                :isEditing="true"
                :shipType="delivery.shipType"
                :value="delivery.status"
                :shippingItems="delivery.items"
                :isStatus="true"
              ></field-stage>
            </template>
          </mf-table>
        </div>
      </section>
      <footer class="modal-card-foot is-justify-content-flex-end">
        <div>
          <button
            class="button has-background-black-bis"
            @click="cancel()">
            Done
          </button>
        </div>
      </footer>
    </div>
    <o-loading
      :full-page="true"
      :active="isLoading"
      :can-cancel="true"
    ></o-loading>
  </div>
</template>

<script>

import { defineComponent, inject, reactive, ref, toRefs } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import MfTable from '@/components/table-fields/MfTable.vue';
import SearchBar from '@/components/SearchBar.vue';
import itemDeliveriesCols from '@/components/table-cols/itemDeliveriesCols';
import { filter, get, isEmpty, pick, find } from 'lodash';

export default defineComponent({
  name: 'ItemDeliveries',
  props: [
    'card',
    'rowData',
  ],
  components: {
    MfTable,
    'search-bar': SearchBar,
  },

  setup(props, { emit }) {
    const route = useRoute();
    const store = useStore();
    const router = useRouter();
    const itemsTable = ref(null);
    const emitter = inject('emitter')

    const tableProps = itemDeliveriesCols;
    const state = reactive({
      shouldEmit: true,
      isLoading: false,
      searchText: '',
      delivery: [],
    })

    const loadData = () => {
      state.delivery = [];
      const deliveries = filter(get(props.card, 'partialShipments', []), (partial) => !["underDelivered", 'unscheduled'].includes(partial.status));
      deliveries.forEach((del) => {
        const itemDelivery = find(del.items, (item) =>  props.rowData.source.kind === 'ProductionOrder' || (props.rowData.source.kind === 'Assembly' && !item.catId) ?
          props.rowData._id === item._id : (props.rowData.catId === item.catId && props.rowData._id === item._id));
        if (!isEmpty(itemDelivery)) {
          const selectedObj = {
            name: del.name,
            total: ['in-transit'].includes(del.status) ? itemDelivery.quantity : '',
            delivered: ['in-storage', 'fulfilled', 'released-to-inventory'].includes(del.status) ? (itemDelivery.quantity - (itemDelivery.underDeliver|| 0)) : '',
            status: del.status,
            shipType: del.shipType,
            items: del.items,
          };
          if (!state.searchText || selectedObj.name.toLowerCase().includes(state.searchText.toLowerCase())) {
            state.delivery.push(selectedObj);
          }
        }
      });
      return { data: state.delivery, total: state.delivery.length };
    };
    const getSearchValue = (searchText) => {
      state.searchText = searchText;
      itemsTable.value.refreshTable();
    };

    const cancel = (doRefresh = false) => {
      emit('close', { doRefresh });
    };

    return {
      ...toRefs(state),
      itemsTable,
      cancel,
      tableProps,
      loadData,
      getSearchValue
    }
  }
})
</script>
<style scoped>
  .modal-card-head {
    background-color: #fff !important;
    border-bottom: none !important;
  }
  .modal-card-foot {
  border-top: 1px solid #84888c;
    background-color: #fff !important;
  }
</style>